import React, { useState } from "react";
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Text,
  VStack,
} from "@chakra-ui/react";
import { AttachmentIcon } from "@chakra-ui/icons";

interface FileUploadProps {
  userId: string;
  tableName: string;
  connectionId: string | null;
  onUploadComplete?: (file: File) => void;
  onCancel?: () => void;
}

const FileUpload: React.FC<FileUploadProps> = ({
  userId,
  tableName,
  connectionId,
  onUploadComplete,
  onCancel,
}) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setSelectedFile(e.target.files[0]);
    }
  };

  const handleUploadClick = () => {
    if (selectedFile && connectionId && onUploadComplete) {
      onUploadComplete(selectedFile);
    }
  };

  return (
    <Box p={6} bg="white" borderRadius="lg" boxShadow="md" maxW="500px" mx="auto">
      <VStack spacing={5} align="stretch">
        <FormControl>
          <FormLabel>
            Select file for <strong>{tableName}</strong>
          </FormLabel>
          <Input type="file" onChange={handleFileChange} padding={1} />
        </FormControl>
        {selectedFile && (
          <Box p={3} bg="gray.50" borderRadius="md">
            <Flex align="center">
              <AttachmentIcon mr={2} />
              <Text fontWeight="medium">{selectedFile.name}</Text>
              <Text ml={2} fontSize="sm" color="gray.500">
                ({(selectedFile.size / 1024 / 1024).toFixed(2)} MB)
              </Text>
            </Flex>
          </Box>
        )}
        <Button
          colorScheme="blue"
          onClick={handleUploadClick}
          leftIcon={<AttachmentIcon />}
          disabled={!selectedFile}
          width="full"
        >
          Upload to Azure
        </Button>
        {onCancel && (
          <Button
            variant="link"
            mt={2}
            colorScheme="blue"
            onClick={onCancel}
            width="full"
          >
            ← Cancel
          </Button>
        )}
      </VStack>
    </Box>
  );
};

export default FileUpload;
